var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"MainLayout backgroundColor",attrs:{"direction":"vertical"}},[_c('header-container'),_c('div',{staticClass:"workLayout"},[_c('router-view'),_c('footer-container')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }